import { render, staticRenderFns } from "./tmOverlay.vue?vue&type=template&id=057ab2bc&"
import script from "./tmOverlay.vue?vue&type=script&lang=js&"
export * from "./tmOverlay.vue?vue&type=script&lang=js&"
import style0 from "./tmOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports